module.exports = __webpack_public_path__ + "static/3-f41ffb36c0b1ce369de209b5409b6956.jpg";